import { render } from "./testimonial-two.vue?vue&type=template&id=1d98acac"
import script from "./testimonial-two.vue?vue&type=script&lang=js"
export * from "./testimonial-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__